export const getCorStatusLicencaDispensa = (status) => {
    switch (status) {
        case 'VIGENTE':
            return '#4CAF50'
        case 'SUSPENSA':
        case 'SUSPENSO':
            return '#FFC107'
        case 'CANCELADA':
        case 'CANCELADO':
        case 'CANCELADA_ALTERACAO':
        case 'VENCIDA':
        case 'VENCIDO':
            return '#F44336'
        default:
            return '#000000'
    }
}

export const getCorStatusCarteiraPesca = (status) => {
    switch (status) {
        case 'Aguardando pagamento do boleto':
            return '#e6ac00'
        case 'Vigente':
            return '#00b33c'
        case 'Ativo aguardando pagamento do boleto':
            return '#C5E1A5'
        case 'Invalidado':
            return '#b3b3b3'
        case 'Vencido':
            return '#cc0000'
        case 'Inativo':
            return '#b3b3b3'
        default:
            return '#000000'
    }
}
